export class ClsTerceroLoginModel {
  public Empresa_ID: number;
  public Negocio_ID: number;
  public Negocio_Key: string;
  public Tercero_ID: number;
  public Tercero_Key: string;
  public Correo: string;
  public Password: string;
}
